import {
  Box
} from '@mui/material';

import {
  ProductionState,
} from 'models';


export function StateIndicator({ state }: { state?: ProductionState }) {
  const commonStyles = {
    border: 1,
    borderRadius: 1,
  };
  switch (state || null) {
    case ProductionState.Done:
      return (<Box sx={{ ...commonStyles, color: 'plane' }}>完了</Box>);
    case ProductionState.Running:
      return (<Box sx={{ ...commonStyles, color: 'green' }}>製作中</Box>);
    case ProductionState.Standby:
      return (<Box sx={{ ...commonStyles, color: 'yellow' }}>待機</Box>);
    default:
      return (<Box sx={{ ...commonStyles, color: 'red' }}>不明</Box>);
  }
}
